module.exports = __webpack_public_path__ + "static/media/frame_35.379cf00d.jpg";